/** O logotipo, nas telas anteriores ao painel.
 *
 * Antes eram três blocos iguais copiados em Login, Signup e AcceptInvite:
 * um quadrado vermelho com a chave inglesa do lucide e o nome ao lado. A
 * chave era marcador de lugar — ícone genérico de biblioteca, igual ao de
 * "Serviços" no menu. Quem chegava pelo convite via a mesma chave que via
 * na lista de serviços e não tinha como saber que aquilo era a marca.
 *
 * O arquivo do kit já traz símbolo e lettering juntos, então não há texto
 * a compor aqui: o `alt` carrega o nome para leitor de tela.
 */
export default function Marca({ className = "" }: { className?: string }) {
  return (
    <img
      src="/brand/logo.svg"
      alt="garagem.club"
      width={188}
      height={36}
      className={`h-9 w-auto ${className}`}
    />
  );
}
